var map = {
	"./business-hour-white.svg": "b8f4",
	"./email-white.svg": "557e8",
	"./events-white.svg": "5298",
	"./general-white.svg": "353c",
	"./iot-white.svg": "9bfb",
	"./operator-app-white.svg": "1f1a",
	"./payments-white.svg": "ebfa",
	"./point-white.svg": "f71e",
	"./profile-white.svg": "4a52",
	"./quiz-white.svg": "b875",
	"./rent-white.svg": "084f",
	"./rider-app-white.svg": "e055",
	"./security-white.svg": "cede",
	"./trip-white.svg": "9c8b",
	"./vehicle-white.svg": "b28d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36b7";